import React from 'react';
import { motion } from 'framer-motion';
import { Shield, CreditCard, Smartphone, Lock } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-16 px-4 bg-[#1E3A5F] border-t border-gray-100" data-id="element-25">
      <div className="max-w-2xl mx-auto text-center" data-id="element-26">
        <h2 className="text-2xl md:text-3xl font-bold text-white mb-6" data-id="element-27">
          El uso excesivo de pantallas no se corrige solo. <br data-id="element-28" />
          <span className="text-[#22C55E]" data-id="element-29">Empezá hoy.</span>
        </h2>

        <div className="mb-8" data-id="element-30">
          <div className="flex items-center justify-center gap-2 mb-2" data-id="element-31">
            <span className="text-white/70 line-through text-lg" data-id="element-32">
              Antes $70.000 ARS
            </span>
          </div>
          <div className="flex items-center justify-center gap-3" data-id="element-33">
            <span className="text-2xl" data-id="element-34">🇦🇷</span>
            <span className="text-3xl font-bold text-white" data-id="element-35">Hoy $19.990</span>
          </div>
          <p className="text-sm text-white/70 mt-1" data-id="element-36">Pesos Argentinos</p>
        </div>

        <motion.a href="https://mpago.li/2MQSj3Q" target="_blank" rel="noopener noreferrer" whileHover={{
        scale: 1.02
      }} whileTap={{
        scale: 0.98
      }} className="block w-full bg-[#22C55E] hover:bg-[#16A34A] text-white font-bold text-xl md:text-2xl py-5 px-6 rounded-xl shadow-lg transition-colors mb-8 animate-[pulse_2s_infinite]" data-id="element-37">
          QUIERO ACCESO INMEDIATO
        </motion.a>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 text-sm text-white/90" data-id="element-38">
          <div className="flex items-center justify-center gap-2" data-id="element-39">
            <Lock className="w-4 h-4 text-[#22C55E]" data-id="element-40" />
            <span data-id="element-41">Pago protegido</span>
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-42">
            <CreditCard className="w-4 h-4 text-[#22C55E]" data-id="element-43" />
            <span data-id="element-44">Todos los medios de pago</span>
          </div>
          <div className="flex items-center justify-center gap-2" data-id="element-45">
            <Smartphone className="w-4 h-4 text-[#22C55E]" data-id="element-46" />
            <span data-id="element-47">Acceso automático</span>
          </div>
        </div>
      </div>
    </section>;
}